module.exports = __webpack_public_path__ + "img/img-28.dc1b2f45.png";